import InputLabel from "@mui/material/InputLabel";
import { Integer } from "model/modelTypes";
import InputBoxes from "./CharacterInputBoxes";
import useCodeValue from "./useCodeValue";

type IProps = {
  value?: string;
  setValue: (val?: string) => void;
  length: Integer;
  onChange?: () => void;
  error?: boolean;
  label?: string;
  classes?: {
    label?: string;
  };
};
function CodeInput({
  value,
  setValue,
  label,
  length = 6,
  classes,
  error,
}: IProps) {
  const { valueArr, setValueArr, handlePaste } = useCodeValue({
    value,
    setValue,
    length,
  });

  return (
    <>
      {label && (
        <InputLabel
          className={classes?.label}
          error={error}>
          {label}
        </InputLabel>
      )}
      <div
        style={{ display: "flex", justifyContent: "center" }}
        onPaste={handlePaste}>
        <InputBoxes
          valueArr={valueArr}
          setValueArr={setValueArr}
          length={length}
        />
      </div>
    </>
  );
}

export default CodeInput;
